import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoggedInUserService } from '../../../auth/logged.in.user';
import { CmsDialogDto } from '../../../models/cms.dialogs/cms.dialogs.models';
import { CmsDialogService } from '../../../services/cms.dialog.service';

type HelpTrainingTab = 'overview' | 'booking' | 'rescheduling' | 'cancelling';

@Component({
    selector: 'help-training',
    template: require('./help.training.component.html'),
    styles: [require('../personal.account.shared.css'), require('./help.training.component.css')]
})
export class HelpTrainingComponent implements OnInit, OnDestroy {
    private readonly tabOrder: HelpTrainingTab[] = ['overview', 'booking', 'rescheduling', 'cancelling'];

    selectedTabIndex = 0;
    overviewContent = '';
    bookingContent = `
        <p>You can view upcoming dates, see course details, and book for training directly in the Booking area. You can book and pay for training here too if you wish to pay by card, or
you can receive an invoice for BACS or phone payment. If you are a paid subscriber, you receive a discount on the standard training price.</p
        <p><strong>Helpful tips include:</strong></p>
        <ul>
            <li>If you are a subscriber, log in before booking so your discount applies.</li>
            <li>If you have any issues booking or need help, contact the team.</li>
        </ul>
    `;
    reschedulingContent = `
        <p>If you need to change the date of your training booking, contact the team by replying to your training email or emailing onlinetraining@b2bquotetenders.co.uk. If you need
help urgently or prefer to speak to someone, call us on 01902 712191.</p
        <p>The team will confirm the available options and update your booking as needed (training dates and availability can change).</p>
        <p><strong>Helpful tips include:</strong></p>
        <ul>
            <li>Use the same email address you booked with when contacting the team, so they can locate your booking quickly.</li>
            <li>If you’re rescheduling close to the event date, call so our team can sort it for you quickly.</li>
        </ul>
    `;
    cancellingContent = `
        <p>You can view upcoming dates, see course details, and book for training directly in the Booking area. You can book and pay for training here too if you wish to pay by card, or
you can receive an invoice for BACS or phone payment. If you are a paid subscriber, you receive a discount on the standard training price.</p>


<p>If you need to cancel, the team may be able to:</p>
        <ul>
            <li>Transfer your booking to the next available training date.</li>
            <li>Put the booking on hold if a subsequent training date has not yet been scheduled.</li>
        </ul>

        <p>Refinds will be made in line with the terms of the booking. Where a refund is being processed, you’ll be asked to provide your company bank details (bank account name, sort
code and account number) so the refund can be issued by BACS.</p>

        <p><strong>Helpful tips include:</strong></p>
        <ul>
            <li>If you still want to attend, asking to transfer to the next available date is usually the simplest option.</li>
        </ul>
    `;

    constructor(
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        private readonly cmsDialogService: CmsDialogService,
        private readonly userService: LoggedInUserService) { }

    ngOnInit() {
        document.body.classList.add('personal-account-fit');

        this.route.queryParams.subscribe(params => {
            const tab = this.normalizeTab((params && params.tab ? params.tab : '').toString());
            this.selectedTabIndex = this.tabOrder.indexOf(tab);
            if (this.selectedTabIndex < 0) {
                this.selectedTabIndex = 0;
            }
        });

        const loggedInUser = this.userService.getCurrentUser();
        const subscribed = !loggedInUser.canAdHoc('notSubscribed');
        const description = subscribed ? 'Training Info - Subscribed' : 'Training Info - Not Subscribed';

        this.cmsDialogService.getByDescription(description).subscribe((result: CmsDialogDto) => {
            this.overviewContent = result.body || '';
        });
    }

    ngOnDestroy() {
        document.body.classList.remove('personal-account-fit');
    }

    onTabChange(index: number) {
        const tab = this.tabOrder[index] || 'overview';
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { tab },
            queryParamsHandling: 'merge',
            replaceUrl: true
        });
    }

    private normalizeTab(tab: string): HelpTrainingTab {
        if (tab === 'booking' || tab === 'rescheduling' || tab === 'cancelling' || tab === 'overview') {
            return tab;
        }
        return 'overview';
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/account.management/help/help.training.component.ts